import React from 'react'
import TableHeadings from '../../Components/common-components/table-headings';
import { Checkbox, } from '@mui/material';
const SelectMedicalForm = ({ data, methods, handleShareMedicalForm }) => {
    const {
        medicalHistoryList,
        seletedMedicalForm,
    } = data
    const {
        handleSelectMedicalForm,
        setSeletedMedicalForm,
        setShareMedicalHistoryModal,
    } = methods
    let header = [
        { label: '#' },
        { label: 'Form Name' },
        { label: 'Form Category' },
    ]
    return (
        <>
            <table className="customTable">
                <TableHeadings TableHeadData={header} />
                <tbody>
                    {
                        medicalHistoryList?.map((cur, index) =>
                            <tr key={index}>
                                <>
                                    <td className='ps-1' >
                                        <Checkbox
                                            checked={seletedMedicalForm?.includes(cur?.id)}
                                            onChange={(e) => handleSelectMedicalForm(e, cur?.id)}
                                            size='small'
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        /></td>
                                    <td className='blue3 fw-6 cursor' >{cur?.name}</td>
                                    <td className='blue3 fw-6 cursor' >{cur?.categoryName || '--'}</td>
                                </>
                            </tr>
                        )
                    }
                </tbody>
            </table>
            <div className="row">
                <div className="col-12 pb-3 ">
                    <div className="d-flex justify-content-end pe-3">
                        <div className='me-3'>
                            <button type="submit" className="theme-btn black1 col-11 mt-4 px-5 w-100" onClick={() => { setShareMedicalHistoryModal({ data: null, open: false }); setSeletedMedicalForm([]) }}>Discard</button>
                        </div>
                        <div>
                            <button type="button" className="theme-btn bgDarkBlue col-11 mt-4 px-5 w-100" onClick={handleShareMedicalForm} > Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


const SelectConsentForm = ({ data, methods, handleShareConsentForm }) => {
    const {
        templateList,
        selectConsentForm,
    } = data
    const {
        handleSelectConsentForm,
        setSelectConsentForm,
        setShareConsentForm,
    } = methods
    let header = [
        { label: '#' },
        { label: 'Form Name' },
        { label: 'Form Category' },
    ]
    return (
        <>
            <table className="customTable">
                <TableHeadings TableHeadData={header} />
                <tbody>
                    {
                        templateList?.map((cur, index) =>
                            <tr key={index}>
                                <>
                                    <td className='ps-1' >
                                        <Checkbox
                                            checked={selectConsentForm?.includes(cur?.id)}
                                            onChange={(e) => handleSelectConsentForm(e, cur?.id)}
                                            size='small'
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        /></td>
                                    <td className='blue3 fw-6 cursor' >{cur?.name}</td>
                                    <td className='blue3 fw-6 cursor' >{cur?.formCategory || '--'}</td>
                                </>
                            </tr>
                        )
                    }
                </tbody>
            </table>
            <div className="row">
                <div className="col-12 pb-3 ">
                    <div className="d-flex justify-content-end pe-3">
                        <div className='me-3'>
                            <button type="submit" className="theme-btn black1 col-11 mt-4 px-5 w-100" onClick={() => { setShareConsentForm({ data: null, open: false }); setSelectConsentForm([]) }} > Discard</button>
                        </div>
                        <div>
                            <button type="button" className="theme-btn bgDarkBlue col-11 mt-4 px-5 w-100" onClick={handleShareConsentForm} > Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


const SelectMedicalSingleForm = ({ data, methods, getFormDetails, setaddAndFillFormModal }) => {
    const {
        medicalHistoryList,
    } = data
    const {
        setChooseMedicalHistoryFomrModal,
    } = methods

    let header = [
        { label: '#' },
        { label: 'Form Name' },
        { label: 'Form Category' },
    ]
    return (
        <>
            <table className="customTable">
                <TableHeadings TableHeadData={header} />
                <tbody>
                    {
                        medicalHistoryList?.map((cur, index) =>
                            <tr key={index} onClick={() => { setaddAndFillFormModal((pre) => ({ data: { ...cur, isAddAndFillForm: true }, open: true, })); getFormDetails(cur?.id); setChooseMedicalHistoryFomrModal({ data: null, open: false }) }}>
                                <>
                                    <td className=' cursor' >{index + 1}</td>
                                    <td className=' cursor' >{cur?.name}</td>
                                    <td className=' cursor' >{cur?.categoryName || '--'}</td>
                                </>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </>
    )
}
export { SelectMedicalForm, SelectMedicalSingleForm,SelectConsentForm }